import debug from '../services/debug';

export async function wait(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

// SWP-52: takes a function so each attempt runs it again; a settled promise
// would only re-reject.
export async function retry<T = unknown>(
  asyncFn: () => Promise<T> | T,
  label = '',
  retries = 3,
  delay = 1000,
): Promise<T> {
  try {
    return await asyncFn();
  } catch (error) {
    debug(`promise retry ${label} retries=`, { error, retries });
    if (retries <= 0) {
      return Promise.reject(error);
    }

    await wait(delay);

    return retry<T>(asyncFn, label, retries - 1, delay);
  }
}
